import React, { useState } from 'react'
import { Button, WithPopover } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { MoreActionsPopover } from './MoreActionsPopover'

type Props = {
  shouldDisableActions: boolean
  moreActionsItemHandler: (data: string) => void
}
export const MoreActions = (props: Props) => {
  const { shouldDisableActions, moreActionsItemHandler } = props
  const [isOpen, setIsOpen] = useState(false)
  const togglePopover = () => setIsOpen(!isOpen)
  const closePopover = () => setIsOpen(false)
  const t = useT()

  /**
   * Handle click event on the popover
   * Then close the popover
   */
  const clickHandler = (item: string) => {
    moreActionsItemHandler(item)
    closePopover()
  }

  return (
    <WithPopover className="vd-popover--with-list" direction="bottomLeft">
      <Button
        modifier="text"
        variant="supplementary"
        onClick={togglePopover}
        disabled={shouldDisableActions}
        data-cy={'more-actions-button'}
      >
        <i className="fa fa-caret-down vd-mr1"></i>
        {t('More', { _context: 'More action button' })}
        <span className="wr-hide-on-mobile">
          {' '}
          {t('actions…', {
            _context:
              'The actions part of More actions button. Hide on mobile device',
          })}
        </span>
      </Button>
      {isOpen && (
        <MoreActionsPopover
          closePopover={closePopover}
          shouldDisableActions={shouldDisableActions}
          clickHandler={clickHandler}
        />
      )}
    </WithPopover>
  )
}
